import { useEffect } from "react";

/**
 * Hook to close a modal/dialog on Escape key press.
 * @param {boolean} isOpen - Whether the modal is currently open
 * @param {Function} onClose - Function to call when Escape is pressed
 */
export default function useEscapeKey(isOpen, onClose) {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);
}
